import { Dayjs } from 'dayjs';

export class Schicht {
  constructor({
    id,
    beginn,
    ende,
  }: {
    id: string;
    beginn?: Dayjs;
    ende?: Dayjs;
  }) {
    this.id = id;
    this.beginn = beginn;
    this.ende = ende;
  }
  readonly id: string;
  readonly beginn?: Dayjs;
  readonly ende?: Dayjs;
}
